import ElementX from 'vue-element-plus-x'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ElementX)
})